import { useEffect, useState } from 'react';

export const WREG_DESKTOP_MIN_WIDTH_PX = 1100;

const QUERY = `(min-width: ${WREG_DESKTOP_MIN_WIDTH_PX}px)`;

const matches = (): boolean =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia(QUERY).matches;

const useWregDesktop = (): boolean => {
  const [isDesktop, setIsDesktop] = useState<boolean>(matches);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(QUERY);
    const onChange = () => setIsDesktop(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isDesktop;
};

export { useWregDesktop };
